import {SHOW_MODAL, HIDE_MODAL} from '../actions/index'

const INITIAL_STATE = {
	show: false,
	history: [],
}

const handleChange = (state, change) => {
  const {show, history} = state;
  return ({
    show: change,
    history: [change, ...history]
  })
}

export default function modal(state = INITIAL_STATE, action) {
	const { show, history } = state;

	switch (action.type) {
		case 'SHOW_MODAL':
			return handleChange(state, true);
		case 'HIDE_MODAL':
			return handleChange(state, false);
		default: 
			return state;
	}
}



